// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderCanceled-module__container","helpContainer":"OrderCanceled-module__helpContainer","btn":"OrderCanceled-module__btn"};